import { Reducer } from "redux";
import { Action, ActionType } from "../../actions";
import { ResultsData } from "../../state/IdentitySettings/ResultsData";

const updateResultsData: Reducer<ResultsData> = (state: ResultsData = new ResultsData(), action: Action<ActionType, ResultsData>) => {
  switch (action.type) {
    case ActionType.IDENTITY_SETTINGS_DATA_FETCHED:
      return { ...state, items: action.data};
    default:
      return state;
  }
};

export default updateResultsData;
